export const LIVE = "LIVE";
export const SANDBOX = "SANDBOX"